let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");

module.exports = dd.createClass({
	render(){
		let {message, onYes, onClose} = this.props;
		return Modal({
				title: "Are you sure?",
				buttons: [
					{
						name: "No, never mind",
						onClick: onClose,
						className: "btn btn-default"
					},
					{
						name: "Yes, I am sure",
						onClick: onYes,
						className: "btn btn-primary"
					}
				],
				onClose
			},
			dd.div({className: "row"},
				dd.div({className: "col-sm-3 text-center text-muted"},
					dd.i({
						className: "fa fa-warning text-muted",
						style: {fontSize: 100}
					})
				),
				dd.div({className: "col-sm-9"},
					dd.p({className: "preserve-whitespace"}, message)
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/widgets/ConfirmModal.js